import * as Login from './Login';
import * as Data from './Data';
import * as teamsState from './TeamsState';
import { CustomersState, reducerCustomer } from './customers';
import { ContactsState, reducerContacts } from './contacts';
import { ConsultantsState, reducerConsultants } from './consultants';

// The top-level state object
export interface ApplicationState {
    data: Data.DataState;
    userNeomyticLogin: Login.UserLoginState;
    teamsState: teamsState.TeamsState;
    customersState: CustomersState;
    contactsState: ContactsState;
    consultantsState: ConsultantsState;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    data: Data.reducer,
    userNeomyticLogin: Login.reducer,
    teamsState: teamsState.reducer,
    customersState: reducerCustomer,
    contactsState: reducerContacts,
    consultantsState: reducerConsultants,
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}
